import React from "react";
import cn from "classnames";
import { Badge as BricksBadge, BadgeProps as BricksBadgeProps } from "@red-digital/bricks";

import styles from "./Badge.module.scss";

interface BadgeProps extends BricksBadgeProps {
  color?: "primary" | "secondary";
}

export const Badge: React.FC<BadgeProps> = ({ className, children, color = "primary", ...rest }) => {
  return (
    <BricksBadge
      modifier={400}
      className={cn(className, styles.badge, {
        [styles.primary]: color === "primary",
        [styles.secondary]: color === "secondary",
      })}
      {...rest}
    >
      {children}
    </BricksBadge>
  );
};
